<select-input
  [control]="control"
  [icon]="icon"
  [label]="label"
  [id]="id"
  [iconType]="iconType"
  [placeholder]="placeholder"
  [values]="options"
  [enableSearch]="true"
  [isCountryField]="false"
  [isBasicDropdownValue]="true"
  [isDisabled]="isDisabled"
  key="place_name"
  valueName="place_name"
  [isDropdown]="true"
  [isCityField]="true"
  [hasSearchQueryExternal]="hasSearchQuery"
  (onSearch)="onSearch($event)"
  (valueChanged)="onValueChange($event)"
  [filteredData]="options"
  [clearAll]="true"
  [required]="required"
  [mode]="mode"
  [fieldType]="fieldType"
  (onKeydown)="onKeydownEvent($event)"
  (blurEvent)="onBlurEvent($event)"
></select-input>
